import { analyticsService } from '@common/analytics';
import {
  deleteOrderAPI, loadOrderDetailsAPI, sendOrderReviewAPI
} from '@common/api/api';
import { ANALYTICS_EVENTS } from '@common/analytics/AnalyticsEvents';
import Const, { orderTypeToOrderEventPropName } from '../config/const';
import { advisorOrdersDelete } from './advisor_orders';
import { log, LOG_LEVELS } from '../../common/config/app_logger';
import { toCamelCase } from '../../common/config/utils';
import { addParamsToAnalitycs } from './application';

const loadingOrderDetails = () => ({
  type: Const.orderDetails.loading
});

const sendOrderReviewError = (error) => ({
  type: Const.orderDetails.sendedOrderReviewError,
  error
});

export const sendedOrderReviewClearError = () => ({
  type: Const.orderDetails.sendedOrderReviewClearError
});

export const loadOrderDetails = (orderId) => (dispatch) => {
  dispatch(loadingOrderDetails());
  return loadOrderDetailsAPI(orderId)
    .catch((error) => log(LOG_LEVELS.ERROR, 'Order', 'Error loadOrderDetails', error));
};

export const sendOrderReview = (orderId, feedback, feedbackData) => (dispatch) => {
  dispatch(addParamsToAnalitycs({
    [ANALYTICS_EVENTS.SEND_ORDER_REVIEW]: feedbackData
  }));
  dispatch(loadingOrderDetails());
  sendOrderReviewAPI(feedback, orderId).then(() => {
  })
    .catch((error) => {
      error.json()
        .then(jsonError => {
          log(LOG_LEVELS.ERROR, 'Order', 'Error sendOrderReviewAPI', toCamelCase(jsonError));
          dispatch(sendOrderReviewError(toCamelCase(jsonError).fullMessages[0]));
        })
        .catch(() => {
          log(LOG_LEVELS.ERROR, 'Order', 'Error sendOrderReviewAPI', error);
          dispatch(sendOrderReviewError(error.statusText));
        });
    });
};

export const deleteOrder = (order) => (dispatch) => {
  const {
    id, advisorId, orderType, state
  } = order;
  dispatch(loadingOrderDetails());
  deleteOrderAPI(id).then(() => {
    analyticsService.trackEvent('order deleted', {
      'order id': id,
      'advisor id': advisorId,
      'order type': orderTypeToOrderEventPropName[orderType],
      'order state': state
    });
    dispatch(advisorOrdersDelete(id));
  })
    .catch((error) => log(LOG_LEVELS.ERROR, 'Order', 'Error deleteOrderAPI', error));
};

export const clearOrderDetails = () => (dispatch) => {
  dispatch(({ type: Const.orderDetails.clear }));
};
